import React from "react";

import "@tennr/style/index.css";
import "./EventsPage.css";

// Universal
import { MetadataTags } from "@tennr/frontend/components/MetadataTags";
import { PageBackground } from "@tennr/frontend/components/PageBackground";
import { SiteFooter } from "@tennr/frontend/components/SiteFooter";
import { Link } from "@tanstack/react-router";

import { HeroSection } from "@tennr/frontend/sections/HeroSection";
import { Heading } from "@tennr/frontend/components/Heading";
import { EventResourceCard } from "@tennr/frontend/components/EventResourceCard";
import { ContentGrid } from "@tennr/frontend/components/ContentGrid";

const cards: any[] = [

{
  title: "2025 NICA Annual Conference",
  url: "https://infusioncenter.org/preferred-partner/tennr/",
  date: "June 20, 2025",
  contentType: "upcoming event",    
  location: "Miami Beach, FL"
},
{
  title: "Becker's Behavioral Health Summit",
  url: "https://conferences.beckershospitalreview.com/behavioralhealth-2025/7405351",
  date: "June 20, 2025",
  contentType: "upcoming event",    
  location: "Chicago, IL"
},
{
  title: "KMESA Annual Conference",
  url: "https://www.vgm.com/events/government-relations/inperson-kmesa-annual-conference/eid_9d1bf14fd74c6f4e/",
  date: "July 16, 2025",
  contentType: "upcoming event",    
  location: "Lexington, KY"
},
{
  title: "FAHCS 2025 Annual Meeting & Exhibit Show",
  url: "https://www.fahcs.us/event-5873011",
  date: "July 30, 2025",
  contentType: "upcoming event",    
  location: ""
},{
  title: "ACMESA 2025 Summer Meeting & Exhibit Show",
  url: "https://atlanticcoastmesa.org/event-5794381",
  date: "August 13, 2025",
  contentType: "upcoming event",    
  location: "Orlando, FL"
},
{
  title: "Big Sky Association of Medical Equipment Suppliers",
  url: "https://www.bigskyames.org/page/page/9082354.htm",
  date: "August 13, 2025",
  contentType: "upcoming event",    
  location: "Anaconda, MT"
}
];
export const EventsPage: React.FC = () => {
  return (
    <>
      <MetadataTags
        title="Events | Tennr"
        description="Connect with Tennr at conferences, webinars, and workshops—wherever you are."
        imageUrl="https://tennr.com/share_cards/sharecard.png"
      />
      <main className="events-page">
        <PageBackground bgImage="/img/events-hero-bg.jpg" bgImageVert="/img/events-hero-bg-vert.jpg" />
        <HeroSection
          noAnimate={true}
          cmsContent={{
            heading: {
              title: "JOIN US",
              heading: "Events with Tennr",
              body: "We'd love to connect with you.",
            },
          }}
        />
        <section className="event-grid">
          <Heading
            className="events-heading"
            title="Upcoming Events"
            heading="Find us in person or online"            
            body="Connect with Tennr at conferences, webinars, and workshops—wherever you are."
          />
          <ContentGrid className="three-col" gridGap="26px 28px">
            {[...cards].map((card, idx) => (
              <EventResourceCard {...card} idx={idx} type="event" />
            ))}
          </ContentGrid>
        </section>
        {/* <section className="past-event-grid">
          <Heading
            className="past-events-heading"
            heading="Past Events"
            title="What we've hosted"
            body="Don't worry, there's more to come."
          />
          <ContentGrid className="four-two-col three-col" gridGap="1em">
            {[...cards, ...cards, ...cards, ...cards].map((card, idx) => (
                <EventResourceCard {...card} idx={idx} type="event" />
            ))}
          </ContentGrid>
        </section> */}
      </main>
      <SiteFooter taglinePosition="left" bgImage="/img/footer-product-bg.jpg" bgImageVert="/img/footer-product-bg-vert.jpg" />
    </>
  );
};
